import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageUtil } from 'src/utils/storage.util';


class CustomTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient){}
    getTranslation(lang: string): Observable<any> {
        return this.http.get('/dist/assets/translations/vo.json');
    }
}
class TranslateLocalLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return from(new Promise(async (resolve, reject) => {
            var translations = StorageUtil.get('translations')
            resolve(translations);
        }))
    }
}
export class CustomMissingTranslationHandler  {
    handle(params: any) {
        if (!environment.production) {
            console.warn('Missing Translation for:', params.key);
        }
        return '';
    }
}
export function TranslationHttpLoader(http: HttpClient) {
    let loader: TranslateLoader;

    if (!environment.production) {
        loader = new CustomTranslateLoader(http);
    } else {
        loader = new TranslateLocalLoader();
    }
    return loader;
}
